const Subject = {

    // FIELDS
    "subject_name": "Subject Name",
    "subject_code": "Subject Code",
    "subject_type": "Subject Type",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "subject": "Subject",

    // ERROR
    "error_name": "Enter Subject Name",
    "error_code": "Enter Subject Code",
    "error_type": "Select Subject Type",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": "SUBJECT NAME",
    "table_code": "SUBJECT CODE",
    "table_type": "SUBJECT TYPE",
    "table_status": "STATUS",

}

export default Subject;
